module.exports = __webpack_public_path__ + "img/chevron-up-solid.ca754458.svg";